module.exports = __webpack_public_path__ + "static/media/illustration-business-plan.1c3dc63d.svg";